import axios from "axios";

const EmployeeFinancialService = {

  // ── POST APIs ──────────────────────────────────────────────────────────────

  async postPayment(data) {
    try {
      const response = await axios.post("/UserRegister/PostPayment", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Payment", error);
      throw error;
    }
  },

  async postWelfareBenefits(data) {
    try {
      const response = await axios.post("/UserRegister/PostWelfareBenefits", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Welfare Benefits", error);
      throw error;
    }
  },

  async postImportantInformation(data) {
    try {
      const response = await axios.post("/UserRegister/PostImportantInformation", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Important Information", error);
      throw error;
    }
  },

  // ── GET APIs ───────────────────────────────────────────────────────────────

  async getPayment(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetPayment", {
        params: { serviceNo: serviceNo },
      });
      console.log("getPayment RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Payment", error);
      throw error;
    }
  },

  async getWelfareBenefits(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetWelfareBenefits", {
        params: { serviceNo: serviceNo },
      });
      console.log("getWelfareBenefits RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Welfare Benefits", error);
      throw error;
    }
  },

  async getImportantInformation(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetImportantInformation", {
        params: { serviceNo: serviceNo },
      });
      console.log("getImportantInformation RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Important Information", error);
      throw error;
    }
  },
};

export default EmployeeFinancialService;